import type { ReactNode } from 'react';

import { Icon } from './Icon.js';
import type { IconName } from './Icon.js';

export interface EmptyStateProps {
  /** An icon name or a custom illustration element for the top of the card. */
  icon?: IconName | ReactNode;
  title: string;
  /** One or two friendly sentences telling the person what to do next. */
  body?: ReactNode;
  /** Optional call-to-action (usually a Button). */
  action?: ReactNode;
  className?: string;
}

/** A friendly placeholder for empty lists and first-run screens. */
export function EmptyState({ icon = 'sparkle', title, body, action, className }: EmptyStateProps) {
  return (
    <div className={['pt-empty', className].filter(Boolean).join(' ')}>
      <div className="pt-empty__art">
        {typeof icon === 'string' ? <Icon name={icon as IconName} size={72} /> : icon}
      </div>
      <div className="pt-empty__title">{title}</div>
      {body ? <p className="pt-empty__body">{body}</p> : null}
      {action}
    </div>
  );
}
